import { css } from 'styled-components'

export const customScrollbar = css`
  @supports not selector(::-webkit-scrollbar) {
    scrollbar-color: var(--t-scrollbar-thumb) transparent;
  }

  &::-webkit-scrollbar {
    width: 18px;
    height: 18px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--t-scrollbar-thumb);
    border: 6px solid transparent;
    background-clip: content-box;
  }

  &::-webkit-scrollbar-thumb:horizontal {
    border-left: 0;
    border-right: 0;
    border-radius: 3px / 9px;
  }

  &::-webkit-scrollbar-thumb:vertical {
    border-top: 0;
    border-bottom: 0;
    border-radius: 9px / 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: var(--t-scrollbar-thumb);
  }

  &::-webkit-scrollbar-button {
    display: none;
    width: 0;
    height: 0;
  }

  &::-webkit-scrollbar-corner {
    background: transparent;
  }
`
